// removed by extract-text-webpack-plugin
module.exports = {"Avatar":"Avatar__Avatar___2BH2D","HasImage":"Avatar__HasImage___QlgW8","Img":"Avatar__Img___3uPEJ","Caption":"Avatar__Caption___oYIpr","Icon":"Avatar__Icon___1yqwm","InPopup":"Avatar__InPopup___rKieg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Profile/Avatar/Avatar.scss
// module id = 1374
// module chunks = 0